module.exports = __webpack_public_path__ + "static/media/zam5_1.1de4b880.jpg";